import React from 'react';
import PropTypes from 'prop-types';

import ArrowBack from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

class AddCategoryDialogItem extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleBackClick: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleCreateCategory: PropTypes.func,
  };

  state = {
    categoryName: '',
    errorState: false,
  };

  handleChange = e => {
    this.setState({ categoryName: e.target.value });
  };

  addCategory = () => {
    if (this.state.categoryName.trim().length === 0) {
      this.setState({ errorState: !this.state.errorState });
    } else {
      this.props.handleCreateCategory(this.state.categoryName);
      this.props.handleClose();
    }
  };

  displayError = () => {
    const { classes } = this.props;
    return this.state.errorState ? (
      <Typography className={classes.errorText}>You cannot have a blank category name</Typography>
    ) : (
      <Typography />
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <DialogTitle>
          <div className={classes.titleContainer}>
            <div className={classes.leftHeader}>
              <IconButton aria-label="back" onClick={this.props.handleBackClick}>
                <ArrowBack />
              </IconButton>
              <Typography variant="h5">Add a category</Typography>
            </div>
            <div>
              <IconButton aria-label="close" onClick={this.props.handleClose}>
                <ClearIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth={true}
            error={this.state.errorState}
            id="add-category"
            label="Category Name"
            className={classes.textfield}
            value={this.state.categoryName}
            onChange={this.handleChange}
            variant="outlined"
          />
          {this.displayError()}
        </DialogContent>
        <DialogActions>
          <Button className={classes.buttons} onClick={this.props.handleClose}>
            Cancel
          </Button>
          <Button
            onClick={this.addCategory}
            variant="contained"
            color="secondary"
            disabled={!this.state.categoryName}
          >
            Save
          </Button>
        </DialogActions>
      </>
    );
  }
}

export default AddCategoryDialogItem;
